



























































import { Vue, Component, Ref } from "vue-property-decorator";
import {
  get_kinggrid_sign_list,
  verify_kg_pwd,
  KinggridSigItem,
  KinggridSignListApiResult
} from "./config";

import { Loading } from "element-ui";

import kinggrid from "../kinggrid";

@Component({
  name: "FileSign",
  components: {}
})
export default class FileSign extends Vue {
  private visible: boolean = false;

  private index: number = 0;

  private kgData!: KinggridSignListApiResult;

  private loading!: { close(): void };

  @Ref("form")
  private elform!: {
    validate(): Promise<boolean>;
    resetFields(): void;
    clearValidate(): void;
  };

  private form = {
    password: ""
  };

  private rules = {
    password: {
      required: true,
      message: "请输入签章密码"
    }
  };

  private signList: KinggridSigItem[] = [];

  onSignChecked(index: number) {
    this.index = index;
  }

  loadSignImg(signItem: KinggridSigItem): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = signItem.imgdata;
      img.onload = function () {
        resolve(true);
      };
      img.onerror = function () {
        resolve(true);
      };
    });
  }

  async getSignList() {
    this.loading = Loading.service({
      fullscreen: true,
      text: "加载中...",
      body: true,
      customClass: "sign-loading"
    });

    const client = await kinggrid.getLocalClientInfo();

    let result;
    if (client.success) {
      console.log("本地客户端获取keysn成功 => " + client.data.keysn);
      result = await get_kinggrid_sign_list(client.data.keysn);
    } else {
      console.log("本地客户端获取keysn失败，默认使用当前系统登录账号作为keysn");
      result = await get_kinggrid_sign_list();
    }

    if (!result.success) {
      this.loading.close();
      return this.$message.error(result.message);
    }
    this.kgData = result.data;
    console.log(result.data);

    const signList = this.kgData.seals.map((d) => {
      const imgext = d.imgext;
      let prefix = "data:image/" + imgext.replace(".", "");
      return {
        ...d,
        imgdata: prefix + ";base64," + d.imgdata
      };
    }) as KinggridSigItem[];

    for (let i = 0; i < signList.length; i++) {
      await this.loadSignImg(signList[i]);
    }
    this.signList = signList;
    this.loading.close();
  }

  reset() {
    this.form.password = "";
    this.elform?.resetFields();
    this.index = 0;
    this.signList = [];
  }

  show() {
    this.visible = true;
    this.reset();
    this.getSignList();
  }
  hide() {
    this.visible = false;
    this.reset();
  }

  async submit() {
    this.loading = Loading.service({
      fullscreen: true,
      text: "加载中...",
      body: true,
      customClass: "sign-loading"
    });
    try {
      const result = await this.elform.validate();
      if (!result) return;

      const pwdok = await verify_kg_pwd(this.kgData.keysn, this.form.password);
      if (!pwdok) return this.$message.error("密码错误");

      const sign = this.signList[this.index];
      this.$emit("sign", {
        signName: sign.signname,
        imgExt: sign.imgext,
        imgData: sign.imgdata,
        width: sign.width,
        height: sign.height,
        imgTag: sign.imgtag,
        keySn: this.kgData.keysn,
        signSn: sign.signsn,
        password: this.form.password
      });
      this.hide();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.close();
    }
  }
}
